var map = {
	"./book-active.svg": [
		30991,
		991
	],
	"./chat-active.svg": [
		64846,
		4846
	],
	"./clock-active.svg": [
		67349,
		7349
	],
	"./dash-active.svg": [
		61241,
		1241
	],
	"./grades-active.svg": [
		31154,
		1154
	],
	"./info-active.svg": [
		77075,
		7075
	],
	"./live-class-active.svg": [
		55921,
		5921
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8514;
module.exports = webpackAsyncContext;